import { React, useState } from "react";
import './bookingShared.css';
import './bookingStep3.css';
import creditIcon from '../../assets/icons/creditIcon.svg';
import phoneIcon from '../../assets/icons/phoneIcon.svg';

const PAYMENT_METHODS = [
    {
        id: "card",
        label: "Credit / Debit Card",
        icon: <img src={creditIcon} alt="Credit Card Icon" />,
    },
    {
        id: "wallet",
        label: "Mobile Wallet",
        icon: <img src={phoneIcon} alt="Mobile Wallet Icon" />,
    },
];

const PRICES = { day: 9, vip: 200 };
const TICKET_LABELS = { day: "One Day Pass", vip: "VIP" };

export default function BookingStep3({ onNext, onBack, formData, isSubmitting }) {
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [errors, setErrors] = useState({});

    const pricePerTicket = PRICES[formData.ticketType] ?? 0;
    const totalAmount = pricePerTicket * (formData.quantity ?? 1);

    function handleSubmit(e) {
        e.preventDefault();
        if (!paymentMethod) {
            setErrors({ paymentMethod: "Please select a payment method." });
            return;
        }
        onNext({ paymentMethod });
    }

    return (
        <form className="bookingForm" onSubmit={handleSubmit} noValidate>

            <div className="bookField">
                <span className="bookLabel">
                    Payment Method <span className="req">*</span>
                </span>
                <div className="paymentList">
                    {PAYMENT_METHODS.map((m) => (
                        <button
                            key={m.id}
                            type="button"
                            className={`paymentOption ${paymentMethod === m.id ? "selected" : ""} ${errors.paymentMethod ? "inputError" : ""}`}
                            onClick={() => {
                                setPaymentMethod(m.id);
                                setErrors({});
                            }}
                        >
                            <div className="paymentIcon">{m.icon}</div>
                            <h5>{m.label}</h5>
                        </button>
                    ))}
                </div>
                {errors.paymentMethod && <p className="fieldError">{errors.paymentMethod}</p>}
            </div>

            <div className="bookingSummary">
                <h3 className="summaryTitle">Booking Summary</h3>
                <div className="summaryRow">
                    <h4>Date:</h4>
                    <h4>{formData.date}</h4>
                </div>
                <div className="summaryRow">
                    <h4>Ticket Type:</h4>
                    <h4>{TICKET_LABELS[formData.ticketType]}</h4>
                </div>
                <div className="summaryRow">
                    <h4>Number of Tickets:</h4>
                    <h4>{formData.quantity}</h4>
                </div>
                <div className="summaryRow">
                    <h4>Price per Ticket:</h4>
                    <h4>{pricePerTicket} EGP</h4>
                </div>
                <div className="summaryRow total">
                    <h4>Total Amount:</h4>
                    <h4>{totalAmount} EGP</h4>
                </div>
            </div>

            <div className="formFooter">
                <button type="button" className="backBtn" onClick={onBack} disabled={isSubmitting}>
                    Back
                </button>
                <button type="submit" className="nextBtn" disabled={isSubmitting}>
                    {isSubmitting ? "Confirming…" : "Confirm"}
                </button>
            </div>

        </form>
    );
}